export const full_partner_name = 'Premier Employee solutions';
export const short_partner_name = 'Premier';